<template>
  <div>
    <el-steps :active="activeNumber" align-center>
      <el-row class="custom-step-row">
        <el-col v-for="(item, index) in stepList" :key="index" :span="8" class="custom-step-col">
          <div class="custom-step-box">
            <i class="el-icon-loading countIcon" v-if="activeNumber+1 === index"></i>
            <svg-icon
              v-else-if="activeNumber >= index"
              slot="icon"
              icon-class="complete"
              class="countIcon"
            ></svg-icon>
            <svg-icon v-else slot="icon" icon-class="unfinished" class="countIcon"></svg-icon>
            <div
              class="line"
              :style="{
                background: activeNumber >= index ? '#1890ff' : '#d9d9d9'
              }"
              v-show="index !== stepList.length - 1"
            ></div>
          </div>
          <div
            class="custom-step-text"
            :style="{
              color: activeNumber >= index ? '#54585A' : '#D9D9D9'
            }"
          >{{ item.name }}</div>
        </el-col>
      </el-row>
    </el-steps>
  </div>
</template>
<script>
import { timetrans } from '@/utils/validate';

export default {
  name: 'OrderState',
  props: {
    activeNumber: Number
  },
  data() {
    return {
      timetrans,
      stepList: [
        { name: '订单支付' },
        { name: '商家审核' },
        { name: '服务准备' }
      ]
    };
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.custom-step-row {
  width: 920px;
  margin: 0 auto;
}
.custom-step-col {
  text-align: center;
}
.countIcon {
  width: 35px;
  height: 35px;
  font-size: 35px;
  margin-bottom: 20px;
}

.line {
  width: 168px;
  height: 1px;
  position: absolute;
  top: 17px;
  right: -83px;
}
.custom-step-box {
  position: relative;
}
.custom-step-text {
  font-family: PingFangSC,helvetica neue,hiragino sans gb,arial,microsoft yahei ui,microsoft yahei,simsun,sans-serif!important;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderState/index.vue